import React from 'react';

const Chevron = ({ color, ariaLabel }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.409"
      height="10.565"
      viewBox="0 0 17.409 10.565"
      role="img"
      aria-label={ariaLabel}
    >
      <path
        fill={color}
        className="a"
        d="M13.684,133.779l-7.748-7.748a.957.957,0,0,1,0-1.353l.9-.9a.957.957,0,0,1,1.351,0l6.169,6.14,6.169-6.14a.957.957,0,0,1,1.351,0l.9.9a.957.957,0,0,1,0,1.353l-7.748,7.748A.957.957,0,0,1,13.684,133.779Z"
        transform="translate(-5.656 -123.494)"
      />
    </svg>
  );
};

export default Chevron;
